export default "__VITE_ASSET__qH4_phpf__"